module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/eaeb23f373203785501e12ece22ebe9e.png";